export default {
	headerInfo: {
		title: 'Attribute filters in product list',
		description: 'If the toggle is hide, users won\'t be able to filter products by the attribute in product list, but will see the attribute in product detail specification.',
	},
};
